import React, { Component } from 'react';
import platform from "Pub/js/platform";
import { getMulti } from "Pub/js/getMulti";
import Axios from "axios";
import Video from './Video';

import './index.less';

const { base } = platform;
const { NCModal, NCTabs } = base;
const NCTabPane = NCTabs.NCTabPane;

class VideoGuide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [], // 视频数据
            activeVideo: {}, // 当前选中的视频
            activeTab: '', // 当前选中的页签
            json: {},
            autoPlay: false, // 是否自动播放
        };
        this.listRef = React.createRef();
    }

    componentDidMount() {
        let callback = json => {
            // TODO: 如果本地调试，路径换成../../public/VideoGuideData.json
            // 请求数据
            Axios.get('../../VideoGuideData.json').then(res => this.setState({ data: res.data, json: json, activeVideo: res.data[0].videos[0], activeTab: res.data[0].id }));
        };
        getMulti({
            moduleId: "VideoGuide",
            domainName: "workbench",
            callback,
        });
    }

    // 渲染视频弹窗的头部
    renderGuideHead = () => {
        const { data, activeTab, json } = this.state;
        // return (
        //     <NCTabs
        //         defaultActiveKey={data[0] && data[0].id}
        //         tabBarStyle="simple"
        //         activeKey={activeTab}
        //         onTabClick={this.onTabClick}
        //         className="video_guide-tabs"
        //     >
        //         {
        //             data.map(item => {
        //                 let { id, name } = item;
        //                 const { json } = this.state;
        //                 name = json[name.split('_')[0]];
        //                 return (<NCTabPane tab={name} key={id}></NCTabPane>);
        //             })
        //         }
        //     </NCTabs>
        // );
        return <div className='video_guide-title'>{json['videoGuide-0001']}</div>;
    }

    onTabClick = key => {
        this.setState({ activeTab: key });
        const { data } = this.state;
        const element = document.getElementById(data[0].id);
        const element2 = document.getElementById(data[1].id);
        let elementHeight = element.offsetHeight;
        let elementHeight2 = element2.offsetHeight;
        let target;
        if (elementHeight2 > this.listRef.current.offsetHeight) {
            // 如果第二个高度超出容器高度，target是第一次 的
            target = elementHeight + 32;
        } else {
            target = elementHeight - (this.listRef.current.offsetHeight - elementHeight2) + 32;
        }
        if (key === 'product_introduce') {
            this.listRef.current.scrollTop = 0;
        } else {
            this.listRef.current.scrollTop = target;
        }
        console.log(this.listRef.current);
    }

    debounceScroll = e => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.onListScroll(e);
        }, 500);
    }

    onListScroll = e => {
        const { data } = this.state;
        const element = document.getElementById(data[0].id);
        const element2 = document.getElementById(data[1].id);
        let elementHeight = element.offsetHeight;
        let elementHeight2 = element2.offsetHeight;
        let target;
        if (elementHeight2 > this.listRef.current.offsetHeight) {
            // 如果第二个高度超出容器高度，target是第一次 的
            target = elementHeight + 32;
        } else {
            target = elementHeight - (this.listRef.current.offsetHeight - elementHeight2) + 32;
        }
        if (this.listRef.current.scrollTop >= target) {
            this.setState({ activeTab: data[1].id });
        } else {
            this.setState({ activeTab: data[0].id });
        }
    }

    // 渲染视频弹窗列表区域
    renderGuideVideo = () => {
        const { data, activeVideo, activeTab, autoPlay, json } = this.state;
        const { show } = this.props;
        return (
            <div className='video_guide-container'>
                <div className='video_guide-left' ref={this.listRef} onScroll={e => this.debounceScroll(e)}>
                    <div className='video_guide-classify-container'>
                        {
                            data.map((item, idx) => {
                                let { id, videos, name } = item;
                                let className = `video_guide-classify ${id === activeTab ? 'avtive_classify' : ''}`;
                                name = json[name.split('_')[0]];
                                return (
                                    <div className={className} key={id} id={id}>
                                        <div className='video_guide-classify-title'>
                                            <div className='video_guide-classify-sign'></div>
                                            <div className='video_guide-classify-text'>{name}</div>
                                        </div>
                                        {
                                            videos.map((video, index) => this.renderVideoItem(video, index))
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
                <div className='video_guide-right'>
                    {show && <Video {...activeVideo} autoPlay={autoPlay} containerClassName="video_guide-right" langJSON={json} />}
                </div>
            </div>
        );
    }

    renderVideoItem = (video, index) => {
        let { name, id, desc } = video;
        const { activeVideo, json } = this.state;
        let className = 'video_guide-item';
        if (activeVideo.id === video.id) {
            className = 'video_guide-item selected';
        }
        name = json[name.split('_')[0]];
        desc = json[desc.split('_')[0]];
        return (
            <div
                className={className}
                key={id}
                onClick={() => this.setState({ activeVideo: video, autoPlay: true })}
            >
                <div className='video_guide-item-idx'>
                    {`0${index+1}`}
                </div>
                <div className='video_guide-item-info'>
                    <p className='video_guide-item-name'>{name}</p>
                    <p className='video_guide-item-desc'>{desc}</p>
                </div>
            </div>
        );
    }

    onCloseModal = () => {
        const { onCancel } = this.props;
        // 看看后续要不要做状态重置？
        // this.setState({
        //     activeVideo: {}, // 当前选中的视频
        //     activeTab: '', // 当前选中的页签
        //     autoPlay: false, // 是否自动播放
        // });
        onCancel && onCancel();
    }

    render() {
        const { show } = this.props;
        const modalCofig = {
            show: true,
            size: 'xlg',
            resizable: false,
            draggable: false,
            className: "video_guide-modal",
            minWidth: 1165,
            minHeight: 480,
            onCancel: this.onCloseModal,
        };
        return show && (
            <NCModal {...modalCofig}>
                <NCModal.Header closeButton>
                    {this.renderGuideHead()}
                </NCModal.Header>
                <NCModal.Body>
                    {this.renderGuideVideo()}
                </NCModal.Body>
            </NCModal>
        );
    }
}

export default VideoGuide;